import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    heading: "Cine suntem",
    paragraphs: [
      "MEDAS Dental Point, cu sediul în Str. Letea 25, 300425 Timișoara, este operatorul datelor tale cu caracter personal. Ne poți contacta la contact@mymedas.ro sau la telefon 0711 981 550 pentru orice întrebare legată de confidențialitate.",
      "Prelucrăm datele conform Regulamentului (UE) 2016/679 (GDPR) și a Legii nr. 190/2018.",
    ],
  },
  {
    heading: "Ce date colectăm",
    paragraphs: [
      "Date de identificare și contact: nume, telefon, email — atunci când ne ceri o programare sau ne scrii.",
      "Date medicale: informații din chestionarul de pacient și din dosarul medical, necesare pentru tratament.",
      "Date de navigare: informații anonimizate despre cum folosești site-ul (statistici de vizitare).",
    ],
  },
  {
    heading: "De ce le prelucrăm",
    paragraphs: [
      "Pentru programări și comunicarea cu tine (interes legitim și executarea relației medic–pacient).",
      "Pentru întocmirea și păstrarea dosarului medical (obligație legală).",
      "Pentru îmbunătățirea site-ului, pe baza consimțământului tău pentru cookie-uri de analiză.",
    ],
  },
  {
    heading: "Cât timp păstrăm datele",
    paragraphs: [
      "Dosarele medicale sunt păstrate conform termenelor legale aplicabile documentelor medicale.",
      "Cererile de contact și programările online sunt păstrate maximum 12 luni, apoi sunt șterse.",
    ],
  },
  {
    heading: "Drepturile tale",
    paragraphs: [
      "Ai dreptul de acces, rectificare, ștergere, restricționare a prelucrării, portabilitate a datelor și dreptul de opoziție.",
      "Îți poți exercita drepturile scriindu-ne la contact@mymedas.ro. Răspundem în maximum 30 de zile.",
      "Dacă consideri că drepturile îți sunt încălcate, poți depune plângere la ANSPDCP (www.dataprotection.ro).",
    ],
  },
  {
    heading: "Securitatea datelor",
    paragraphs: [
      "Folosim măsuri tehnice și organizatorice adecvate: acces restricționat, conexiuni criptate și instruirea personalului.",
      "Nu vindem și nu cedăm datele tale către terți în scopuri de marketing.",
    ],
  },
];

const PoliticaGdpr = () => (
  <LegalPage
    title="Politica de confidențialitate (GDPR)"
    updated="iulie 2026"
    sections={SECTIONS}
    pageKey="gdpr"
  />
);

export default PoliticaGdpr;
